// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CatalogFeed } from './catalog-feed';
import { Manufacturer } from './manufacturer';
import { Supplier } from './supplier';
import { SupplierImageRole } from './supplier-image-role';
import { CatalogFeedEnum } from './enums';
import { SupplierImageRoleEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class StagedSupplierImage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(50) */
  approximatePms?: string;
  /** Enum FK catalogFeed */
  catalogFeedId!: CatalogFeedEnum;
  /** String(200) */
  colorCode?: string;
  /** Int16 */
  height?: number;
  /** Guid FK manufacturer */
  manufacturerId!: string;
  /** String(255) */
  mimeType?: string;
  /** DateTimeOffset */
  retrievedTs!: Date;
  /** Enum FK role */
  roleId!: SupplierImageRoleEnum;
  /** Binary */
  rowVersion!: any;
  /** Int16 */
  sequenceNo!: number;
  /** String(200) */
  standardColorName?: string;
  /** String(200) */
  styleCode!: string;
  /** Guid FK supplier */
  supplierId!: string;
  /** String(1000) */
  url!: string;
  /** Int16 */
  width?: number;
  /** FK catalogFeedId */
  catalogFeed!: CatalogFeed;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
  /** FK roleId */
  role!: SupplierImageRole;
  /** FK supplierId */
  supplier!: Supplier;
}

